import { render } from "./DeleteShelterDialog.vue?vue&type=template&id=7acf6cc6"
import script from "./DeleteShelterDialog.vue?vue&type=script&lang=js"
export * from "./DeleteShelterDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__